import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EndVisitState,
  SmartNoteCptCode,
  SmartNoteDiagnosis,
  SmartNoteFollowup,
  SmartNoteGCode,
  SmartNoteImaging,
  SmartNoteLab,
  SmartNotePrescription,
  SmartNoteProcedure,
  SmartNoteReferral,
} from "./index.types";

const initialState: EndVisitState = {
  smartNoteImagings: [],
  smartNoteReferrals: [],
  smartNoteProcedures: [],
  smartNoteCptCodes: [],
  smartNoteDiagnosis: {},
  smartNoteLabs: [],
  smartNotePrescriptions: [],
  smartNoteGCodes: [],
  smartNoteFollowups: [],
};

// This slice has the persisted state that will be used to store and persist the smart note data items in case of any accident
export const endVisitSlice = createSlice({
  name: "endVisit",
  initialState,
  reducers: {
    setSmartNoteImagings: (state, action: PayloadAction<SmartNoteImaging[]>) => {
      state.smartNoteImagings = action.payload;
    },
    setSmartNoteReferrals: (state, action: PayloadAction<SmartNoteReferral[]>) => {
      state.smartNoteReferrals = action.payload;
    },
    setSmartNoteProcedures: (state, action: PayloadAction<SmartNoteProcedure[]>) => {
      state.smartNoteProcedures = action.payload;
    },
    setSmartNoteCptCodes: (state, action: PayloadAction<SmartNoteCptCode[]>) => {
      state.smartNoteCptCodes = action.payload;
    },
    setSmartNoteDiagnosis: (state, action: PayloadAction<SmartNoteDiagnosis>) => {
      state.smartNoteDiagnosis = action.payload;
    },
    setSmartNoteLabs: (state, action: PayloadAction<SmartNoteLab[]>) => {
      state.smartNoteLabs = action.payload;
    },
    setSmartNotePrescriptions: (state, action: PayloadAction<SmartNotePrescription[]>) => {
      state.smartNotePrescriptions = action.payload;
    },
    setSmartNoteGCodes: (state, action: PayloadAction<SmartNoteGCode[]>) => {
      state.smartNoteGCodes = action.payload;
    },
    setSmartNoteFollowups: (state, action: PayloadAction<SmartNoteFollowup[]>) => {
      state.smartNoteFollowups = action.payload;
    },
    clearAllSmartNoteData: (state) => {
      state.smartNoteImagings = [];
      state.smartNoteReferrals = [];
      state.smartNoteProcedures = [];
      state.smartNoteCptCodes = [];
      state.smartNoteDiagnosis = {};
      state.smartNoteLabs = [];
      state.smartNotePrescriptions = [];
      state.smartNoteGCodes = [];
      state.smartNoteFollowups = [];
    },
  },
});

export const {
  setSmartNoteImagings,
  setSmartNoteReferrals,
  setSmartNoteProcedures,
  setSmartNoteCptCodes,
  setSmartNoteDiagnosis,
  setSmartNoteLabs,
  setSmartNotePrescriptions,
  setSmartNoteGCodes,
  setSmartNoteFollowups,
  clearAllSmartNoteData,
} = endVisitSlice.actions;

export default endVisitSlice.reducer;
